<div class="item-image" [style.backgroundImage]="imageSrc()"></div>
  <div class="container">
    <app-title [title]="name() || 'Unnamed'" />
    @if (hasAddress()) {
      <app-price [value]="price()" />
    }
    <div class="description" [innerHTML]="safeDescription()"></div>
  </div>